import React, { Component } from "react";

class BrandTwo extends Component{
    render(){
        return(
            <React.Fragment>
                <ul className="brand-style-2">
                    <li>
                        <a target="_blank" href="https://www.facebook.com/Drag-Brunch-at-Le-Moo-1777422202342449/"><img src="/assets/images/brand/brand-01.png" alt="Le Moo"/></a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.eventbrite.com/o/hard-candy-4197978579"><img src="/assets/images/brand/brand-02.png" alt="Hard Candy"/></a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.bloomotr.com/"><img src="/assets/images/brand/brand-10.png" alt="Bloom OTR"/></a>
                    </li>
                    <li>
                        <a target="_blank" href="https://thebirdcagecincinnati.com/"><img src="/assets/images/brand/brand-05.png" alt="Birdcage"/></a>
                    </li>
                    <li>
                    <a target="_blank" href="https://www.tillieslounge.com/"><img src="/assets/images/brand/brand-03.png" alt="Tillies Lounge"/></a>
                    </li>
                    {/* <li>
                        <img src="/assets/images/brand/brand-08.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/brand-06.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/brand-09.png" alt="Logo Images"/>
                    </li>
                    <li>
                        <img src="/assets/images/brand/brand-07.png" alt="Logo Images"/>
                    </li> */}
                </ul>
            </React.Fragment>
        )
    }
}
export default BrandTwo;